import { useMemo } from "react";

import { Alert } from "@mui/material";

import { getComplianceWarnings } from "@features/compliance/orderSetCompliance";

import { useCurrentOrderSet } from "../orderSet/data/CurrentOrderSetContext";

const OrderSetComplianceWarnings = () => {
  const { orders } = useCurrentOrderSet();

  const complianceWarnings = useMemo(
    () => getComplianceWarnings(orders),
    [orders]
  );

  return (
    <>
      {complianceWarnings.length > 0 && (
        <Alert
          severity="warning"
          title="Compliance Pending"
          className="-m-2 text-sm text-amber-900 bg-amber-100 rounded-lg"
        >
          <div className="divide-y-2 divide-amber-100">
            {complianceWarnings.map(({ sku, type, state }, i) => (
              <div key={i}>
                {type === "price" ? (
                  <>
                    Item <b>#{sku}</b> is in violation of a pricing rule for the
                    state of <b>{state ?? "---"}</b>. Please keep this order as
                    a Draft order, and contact Gallo Compliance to override the
                    rule for this order.
                  </>
                ) : type === "prior-approval" ||
                  type === "coupon-prior-approval" ? (
                  <>
                    Item <b>{sku}</b> is flagged by a Prior Approval Rule for
                    the state of <b>{state ?? "---"}</b>. Please allow 3-5
                    business days for the state to review.
                  </>
                ) : type === "internal-approval" ||
                  type === "coupon-internal-approval" ? (
                  <>
                    Item <b>{sku}</b> shipping to <b>{state ?? "---"}</b> needs
                    internal approval from GALLO before this order set may be
                    approved.
                  </>
                ) : (
                  <>
                    Item <b>#{sku}</b> is flagged by a Manual Approval Rule for
                    the state of <b>{state ?? "---"}</b>. Please contact Gallo
                    Compliance to review it before attempting to place this
                    order.
                  </>
                )}
              </div>
            ))}
          </div>
        </Alert>
      )}
    </>
  );
};

export default OrderSetComplianceWarnings;
